var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.317 5.468.01.01.009.008a.2.2 0 0 1 .054.141v19.14a.226.226 0 0 1-.232.233H1.623a.226.226 0 0 1-.233-.232V1.232c0-.134.099-.232.233-.232h19.14c.067 0 .116.026.141.054l.009.01.01.01z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.798.5v8.057c0 .41.323.732.733.732H19.25c.41 0 .732-.322.732-.732V.5zm13.916 11.816H6.066a.725.725 0 0 0-.732.733V25.5h16.113V13.049a.725.725 0 0 0-.733-.733Z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.71 16.926a.732.732 0 1 0-1.035 1.035l1.465 1.465a.73.73 0 0 0 1.036 0l2.93-2.93a.732.732 0 1 0-1.036-1.035l-2.412 2.411zM8.996 22.57h8.789a.732.732 0 1 0 0-1.465h-8.79a.732.732 0 1 0 0 1.465m8.461-16.64a.73.73 0 0 0 .732-.733V3.732a.732.732 0 1 0-1.465 0v1.465c0 .405.328.733.733.733",
    fill: "#E5A033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.89.5h25v25h-25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSave);
export default __webpack_public_path__ + "static/media/ic_save.53b8f295b609d0c464b8dcc29a120d25.svg";
export { ForwardRef as ReactComponent };